import { useEffect } from "react";
import { Link } from "react-router-dom";

const MARKETING_URL = "https://zoeyorganizer.com";

export function NotFoundPage() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 p-6 text-center bg-gray-50 dark:bg-gray-950">
      <img
        src="/icon-192.png"
        alt=""
        className="w-24 h-24 rounded-3xl shadow-md"
        draggable={false}
      />
      <div className="space-y-2 max-w-sm">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          We can't find that page.
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          It might have moved, or the link might be a little off.
        </p>
      </div>
      <div className="flex flex-col items-center gap-3 mt-2">
        <Link
          to="/"
          className="px-6 py-2.5 rounded-full text-white font-semibold transition-opacity hover:opacity-90"
          style={{ backgroundColor: "var(--accent-color, #00C7BE)" }}
        >
          Back to home
        </Link>
        <a
          href={MARKETING_URL}
          className="text-sm text-gray-500 hover:text-[color:var(--accent-color,#00C7BE)] underline-offset-2 hover:underline"
        >
          Go to zoeyorganizer.com
        </a>
      </div>
    </div>
  );
}
